module.exports = __webpack_public_path__ + "assets/images/BSD50.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BSD50.png
// module id = 1319
// module chunks = 1